import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { camerasApi } from '@/api/endpoints'
import type { DetectorConfigPatch } from '@/types'

export function useDetectionConfig(cameraId: number, open: boolean) {
  const qc = useQueryClient()
  const key = ['camera-ai-model-configs', cameraId]
  const query = useQuery({ queryKey: key, queryFn: () => camerasApi.getAiModelConfigs(cameraId), enabled: open })
  const mutation = useMutation({
    mutationFn: (patch: DetectorConfigPatch) => camerasApi.updateAiModelConfigs(cameraId, patch),
    onSuccess: (resp) => qc.setQueryData(key, resp),
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  })
  const reset = useMutation({
    mutationFn: () => camerasApi.resetAiModelConfigs(cameraId),
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  })
  return {
    detectors: query.data?.detectors ?? [],
    ensembleEnabled: query.data?.ensemble_enabled ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    saving: mutation.isPending,
    saveError: mutation.isError,
    patch: mutation.mutate,
    resetCamera: reset.mutate,
    resetting: reset.isPending,
  }
}
